import NewWindowTealIcon from 'images/icons/new-window-teal.svg';
import { icon, link } from './buildingWebsiteLink.styles';

type BuildingWebsiteLinkProps = {
  websiteUrl: string;
  linkText: string;
  ariaLabel?: string;
  onClick?: () => void;
};

export const BuildingWebsiteLink = ({ websiteUrl, linkText, ariaLabel, onClick }: BuildingWebsiteLinkProps) => (
  <a
    href={websiteUrl}
    target="_blank"
    rel="nofollow noopener noreferrer"
    onClick={onClick}
    className={link}
    aria-label={ariaLabel}
  >
    {linkText}
    <img src={NewWindowTealIcon} alt="" className={icon} aria-hidden="true" />
  </a>
);
